var _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.099,
    height: 20.099,
    viewBox: "0 0 20.099 20.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 10.05,
    cy: 10.05,
    r: 10.05,
    transform: "translate(0 0)",
    fill: "#32ba7c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M188.8,160.56l5.167,5.167a10.043,10.043,0,0,0,7.45-9.7v-.285L197.36,152Z",
    transform: "translate(-181.318 -145.977)",
    fill: "#0aa06e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(3.376 4.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M92.127,203.991a1.187,1.187,0,0,1,0,1.648l-.919.919a1.187,1.187,0,0,1-1.649,0L85.533,202.5a1.187,1.187,0,0,1,0-1.649l.919-.919a1.187,1.187,0,0,1,1.649,0Z",
    transform: "translate(-85.2 -196.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M171.707,125.533a1.187,1.187,0,0,1,1.649,0l.919.919a1.187,1.187,0,0,1,0,1.649l-6.974,6.943a1.187,1.187,0,0,1-1.649,0l-.919-.919a1.187,1.187,0,0,1,0-1.649Z",
    transform: "translate(-161.261 -125.2)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.8db035cdc8bdf978e8c38a677345e88b.svg";
export { ForwardRef as ReactComponent };